import { gql } from '@apollo/client'
import {
  CORE_BILLING_PRODUCT_FIELDS,
  CORE_BILLING_PRODUCT_PRICE_FIELDS,
  CORE_BILLING_PRODUCT_TEXT_FIELDS,
  CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS,
} from './fragments'

/* eslint-disable import/prefer-default-export */
export const GET_PLANS = gql`
  ${CORE_BILLING_PRODUCT_FIELDS}
  ${CORE_BILLING_PRODUCT_PRICE_FIELDS}
  ${CORE_BILLING_PRODUCT_TEXT_FIELDS}
  ${CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS}
  query Plans(
        $page: String!
        $language: ProviderProductLanguage!
        $planGrid: Boolean
) {
    billingProviderProductList(
        planGrid: $planGrid,
        page: $page,
        billingProduct: { platform: { eq: Gaia } },
        billingProvider: { name: { eq: zuora } },
        deviceType: Desktop,
        language: $language
    ) {
        billingProviderProducts {
          id
          ...CoreBillingProviderProductFields
          billingProduct {
                  ...CoreBillingProductFields
          }
          billingProviderProductPrices {
                  ...CoreBillingProductPricingFields
          }
          billingProviderProductText(language: $language) {
                  ...CoreBillingProductTextFields
          }
        }
    }
}
`

export const GET_PLANS_BY_SKU = gql`
  ${CORE_BILLING_PRODUCT_FIELDS}
  ${CORE_BILLING_PRODUCT_PRICE_FIELDS}
  ${CORE_BILLING_PRODUCT_TEXT_FIELDS}
  ${CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS}
  query PlansBySku(
        $language: ProviderProductLanguage!
        $skus: [String]
        $priceReplacementType: SubscriptionPricingReplacementType = none
        $eligibilityPage: PlanEligibilityPage! = checkout
) {
    billingProviderProductList(
        billingProduct: { platform: { eq: Gaia } },
        billingProvider: { name: { eq: zuora } },
        where: {
            sku: { in: $skus }
            type: { in: [Recurring, Gift] }
        }
    ) {
        billingProviderProducts {
          ...CoreBillingProviderProductFields
          billingProduct {
                  ...CoreBillingProductFields
          }
          billingProviderProductPrices(subscriptionPricingReplacementType: $priceReplacementType) {
                  ...CoreBillingProductPricingFields
          }
          billingProviderProductText(language: $language, subscriptionPricingReplacementType: $priceReplacementType) {
                  ...CoreBillingProductTextFields
          }
          eligible(page: $eligibilityPage)
        }
    }
}
`
